import React from "react";
import DocUp from "../images/docUpload.svg";
function ManageDoc(props) {
 
  return (
    <div
      className={
        props.checkinPage
          ? "homeBox otherServ"
          : "menu-items otherServ cursor-pointer"
      }
      onClick={() => props.open()}
    >
      <div>
        <img src={DocUp} alt="" />
      </div>
      <div className={props.checkinPage ? " mt-1" : "mt-1"}>
        <span>
          Upload ID
          {!props.checkinPage && <br />} Docs
        </span>
      </div>
    </div>
  );
}

export default ManageDoc;
